/* Impression SCDM — remarques du client sur son autocollant.

   Le client peut ecrire une consigne pour l atelier (« imprimer le logo en
   blanc », « centrer le texte », « decouper au ras du contour »). La remarque
   suit le design : elle s affiche dans le recapitulatif et dans l ecran
   d approbation, et surtout elle part avec la commande Shopify.

   Comment ca voyage jusqu a la commande, sans toucher a scdm.js : chaque design
   de window.SCDM.commande porte un objet « props », et scdm.js envoie CHAQUE
   cle de props au panier comme propriete de ligne. Il suffit donc d ajouter la
   remarque dans props au moment ou le design est ajoute, et elle apparaitra
   telle quelle sur la commande, a cote du format et du materiau.

   Charge depuis snippets/scdm-minimum.liquid ; le script sort tout seul quand
   il n y a pas de configurateur sur la page. */

(function () {
  'use strict';

  var CLE = 'Remarques du client';
  var MAX = 450;

  /* LE MOT CHANGE AVEC LA MATIERE — 9 septembre 2026.

     Le lettrage decoupe n est pas imprime : la couleur est dans la masse du
     vinyle et on ne fait qu y tailler les lettres. « Remarques pour
     l impression » y etait donc faux, et l exemple « imprimer le logo en
     blanc » y demandait quelque chose que l atelier ne fera pas.

     SEUL LE TEXTE VU PAR LE CLIENT CHANGE. L identifiant du champ
     (scdmRemarque), son nom et la cle envoyee au panier (CLE, ci-dessus)
     restent identiques : une remarque ecrite sur du lettrage arrive sur la
     commande exactement au meme endroit que les autres. */
  var MATIERE_LETTRAGE = 'lettrage';

  function texteRemarque(cle, repli) {
    var source = document.getElementById('scdmRemarqueI18n');
    return source && source.getAttribute('data-' + cle) || repli;
  }

  var MOTS = {
    impression: {
      label: texteRemarque('print-label', 'Remarques pour l’impression (optionnel)'),
      exemple: texteRemarque('print-example', 'Ex. : imprimer le logo en blanc, centrer le texte, découper au ras du contour…')
    },
    decoupe: {
      label: texteRemarque('cut-label', 'Remarques pour la découpe (optionnel)'),
      exemple: texteRemarque('cut-example', 'Ex. : découper chaque lettre séparément, garder le contour du logo, poser sur transfert…')
    }
  };

  function surDuLettrage() {
    var e = (window.SCDM && window.SCDM.etat) || {};
    return e.matiere === MATIERE_LETTRAGE;
  }

  function mots() { return surDuLettrage() ? MOTS.decoupe : MOTS.impression; }

  var champ = null;
  var compteur = null;
  var etiquette = null;

  /* ---------------------------------------------------------------- style */

  function style() {
    if (document.getElementById('scdmRemStyle')) return;
    var s = document.createElement('style');
    s.id = 'scdmRemStyle';
    s.textContent = [
      '.scdm #scdmRemarque{width:100%;box-sizing:border-box;padding:10px 12px;border-radius:10px;',
      'border:1px solid var(--line);font:inherit;font-size:14px;line-height:1.5;resize:vertical;min-height:76px}',
      '.scdm .rem-compte{margin:5px 0 0;font-size:11.5px;color:var(--slate);text-align:right}',
      '.scdm .cmd-rem{display:block;margin-top:3px;font-size:11.5px;line-height:1.4;color:var(--slate);font-style:italic}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ------------------------------------------------------------ le champ */

  function poser() {
    if (document.getElementById('scdmRemarque')) return true;
    var nom = document.getElementById('scdmNom');
    if (!nom || !nom.parentElement) return false;

    var bloc = document.createElement('div');
    bloc.className = 'fld plein';
    bloc.innerHTML =
      '<label for="scdmRemarque" id="scdmRemLabel"></label>' +
      '<textarea id="scdmRemarque" rows="3" maxlength="' + MAX + '"></textarea>' +
      '<p class="rem-compte"><span id="scdmRemNb">0</span> / ' + MAX + '</p>';

    nom.parentElement.parentNode.insertBefore(bloc, nom.parentElement.nextSibling);

    champ = document.getElementById('scdmRemarque');
    compteur = document.getElementById('scdmRemNb');
    etiquette = document.getElementById('scdmRemLabel');
    champ.addEventListener('input', function () {
      if (compteur) compteur.textContent = String(champ.value.length);
    });
    dire();
    return true;
  }

  /* On n ecrit que si le mot a change : le champ garde le focus et le texte
     deja tape du client, et on n agite pas le DOM a chaque tour d horloge. */
  function dire() {
    var m = mots();
    if (etiquette && etiquette.textContent !== m.label) etiquette.textContent = m.label;
    if (champ && champ.getAttribute('placeholder') !== m.exemple) {
      champ.setAttribute('placeholder', m.exemple);
    }
  }

  function texte() {
    if (!champ) return '';
    return champ.value.replace(/\s+/g, ' ').trim();
  }

  function vider() {
    if (!champ) return;
    champ.value = '';
    if (compteur) compteur.textContent = '0';
  }

  /* ------------------------------------------- accrocher au design ajoute */

  function accrocher() {
    var b = document.getElementById('scdmAjouter');
    if (!b) return;

    var avant = 0;

    /* En capture, on note combien de designs il y avait AVANT le clic. Si
       scdm-vierge.js bloque le clic (un choix manque), il coupe la chaine ici
       et rien de ce qui suit ne se produit : c est voulu. */
    b.addEventListener('click', function () {
      avant = ((window.SCDM && window.SCDM.commande) || []).length;
    }, true);

    /* En bulle, donc apres scdm.js : le design vient d etre cree, on lui
       attache la remarque. Si le nombre n a pas bouge, l ajout a echoue
       (fichier manquant, format hors limites) et on garde le texte pour que le
       client n ait pas a le reecrire. */
    b.addEventListener('click', function () {
      var liste = (window.SCDM && window.SCDM.commande) || [];
      if (liste.length <= avant) return;

      var t = texte();
      if (t) {
        var d = liste[liste.length - 1];
        d.remarque = t;
        d.props = d.props || {};
        d.props[CLE] = t;
      }
      vider();
      peindre();
    }, false);
  }

  /* --------------------------------------- afficher sous chaque ligne */

  function peindreListe(ul) {
    if (!ul) return;
    var liste = (window.SCDM && window.SCDM.commande) || [];
    var lis = ul.children;
    for (var i = 0; i < lis.length; i++) {
      var li = lis[i];

      /* L index vient du bouton « retirer » quand il existe (c est la seule
         source fiable si une ligne a ete supprimee), sinon de la position. */
      var x = li.querySelector('[data-retirer]');
      var idx = x ? parseInt(x.getAttribute('data-retirer'), 10) : i;
      var d = liste[idx];

      var vieux = li.querySelector('.cmd-rem');
      if (vieux) vieux.parentNode.removeChild(vieux);
      if (!d || !d.remarque) continue;

      var hote = li.querySelector('.cmd-info') || li;
      var s = document.createElement('span');
      s.className = 'cmd-rem';
      s.textContent = '✎ ' + d.remarque;
      hote.appendChild(s);
    }
  }

  function peindre() {
    peindreListe(document.getElementById('scdmCmdListe'));
    peindreListe(document.getElementById('scdmApproListe'));
  }

  function surveiller(id) {
    var ul = document.getElementById(id);
    if (!ul) return;
    /* scdm.js reconstruit ces listes a chaque changement : on repose la
       remarque apres chaque reconstruction.

       Pas de garde anti-boucle ici, et c est voulu : on n observe que les
       enfants directs du <ul>, alors que nos propres ajouts se font a
       l interieur des <li>. Ils ne peuvent donc pas nous rappeler. Une garde a
       d ailleurs casse la premiere version : quand scdm.js vide la liste puis
       la reconstruit dans le meme tour, elle avalait la deuxieme mutation et
       les remarques disparaissaient au retrait d une ligne. */
    var o = new MutationObserver(function () { peindreListe(ul); });
    o.observe(ul, { childList: true });
  }

  /* ------------------------------------------------------------ demarrage */

  function demarrer() {
    if (!document.getElementById('scdmConfig')) return;
    style();
    if (!poser()) return;
    accrocher();
    surveiller('scdmCmdListe');
    surveiller('scdmApproListe');
    /* La matiere se change par un clic dans le rail, mais aussi par un modele
       pris au catalogue : on relit l etat plutot que d ecouter un evenement
       qui n existe pas partout. dire() ne touche au DOM que si le mot change. */
    setInterval(dire, 300);
    peindre();
  }

  function quandPret(n) {
    if (document.getElementById('scdmNom') && window.SCDM && window.SCDM.commande) return demarrer();
    if ((n || 0) > 60) return;
    setTimeout(function () { quandPret((n || 0) + 1); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { quandPret(0); });
  } else {
    quandPret(0);
  }
})();
